// extracted by mini-css-extract-plugin
export default {"img":"PeopleCount_img__1rvBi"};